import React from 'react'
import { MdOutlineWhatsapp } from 'react-icons/md'
import Banner from './banner'
import WhatKnow from './what-know'
import FishingStory from './fishing-story'
import Thirukural from './thirukural'
import Who from './who'
import Benefits from './benefits'
import Colleges from './colleges'
import Faq from '../SurgeStudents/faq'
import Header from '../../header'
import Slot from './slot'

export default function SurgeSpeakers() {
    return (
        <div className='relative overflow-hidden w-full'>
            <Header />
            <Banner />
            <WhatKnow />
            <FishingStory />
            <Thirukural />
            <Who />
            <Benefits />
            <Slot />
            <Colleges />
            <div className='w-full bg-[#34C759] mb-[20px] sm:mb-[50px] xl:mb-[70px] p-[20px] md:p-[40px] relative z-0 overflow-hidden text-center'>
                <p className='text-[#FFFFFF] font-semibold text-[16px] md:text-[32px] lg:text-[48px]'>Let’s guide students with truth, not theory.</p>
                <p className='text-[#FFFFFF] font-semibold text-[16px] md:text-[32px] lg:text-[48px]'>Let’s build clarity, not confusion.</p>
                <p className='text-[#FFFFFF] font-semibold text-[16px] md:text-[32px] lg:text-[48px]'>Let’s create capability, not dependency.</p>
                <p className='mt-[10px] md:mt-[40px] font-normal text-[#DBEAFE] text-[12px] md:text-[20px] lg:text-[28px]'>Let’s shape India — together.</p>
                <button className='w-full md:w-[346px] h-[40px] md:h-[64px] mt-[10px] md:mt-[40px]  rounded-[12px] bg-[#FFFF] text-[#34C759] text-[16px] md:text-[24px] font-semibold'
                    onClick={() => {
                        const slotDiv = document.getElementById("slot");
                        if (slotDiv) {
                            slotDiv.scrollIntoView({ behavior: "smooth", block: "start" });
                        }
                    }}>
                    Join The Movement
                </button>
                <div className='mt-[10px] md:mt-[40px]'>
                    <p className='text-[#FFF] font-bold text-[14px] md:text-[20px]'>— SK— </p>
                    <p className='text-[#FFF] font-medium text-[12px] md:text-[16px]'>Founder, Workfast AI | Pepul Tech | MacAppStudio </p>
                </div>
            </div>
            <Faq />
            <div className='border-t border-[#1E2939] text-[12px] md:text-[14px] text-[#99A1AF] font-normal p-[20px] md:px-[42px] text-center flex flex-row-reverse lg:flex-row justify-end lg:justify-between flex-wrap gap-[30px] lg:items-center mx-auto bg-[#000]'>
                <p>© 2025 Surge Students. All rights reserved.</p>
                <div className='w-full md:w-auto'>
                    <p className='font-bold text-[16px] md:text-[20px] text-red-600 text-start'>Connect with us</p>
                    <div className='flex items-center gap-[10px] font-semibold text-[14px] md:text-[18px] mt-[10px]'>
                        <MdOutlineWhatsapp className='text-[#27AE60] flex-shrink-0' />
                        <p >+91 90430 66871 (Whatsapp only)</p>
                    </div>
                </div>
            </div>
        </div>
    )
}
